import { AfterViewInit, Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IExtraFieldConfigurationObject } from '../../shared/formly/ga-formly.service';
import { IGAFormHelper } from './forms.service';

@Component({
  selector: 'forms-container',
  template: `
    <ng-template #regularField>
      <div class="col-space-bottom">
        <h4 class="form-title" *ngIf="sectionTitle" translate>{{sectionTitle}}</h4>
        <forms-help [help]="sectionHelp" [showToggle]="true" [helpId]="sectionId"></forms-help>
        <formly [form]="form" [fields]="fields" [model]="model"></formly>
      </div>
    </ng-template>

    <ng-template #collapsibleField>
      <div class="col-space-bottom">
        <collapsible-pane [title]="sectionTitle" [collapsed]="collapsed">
          <forms-help [help]="sectionHelp" [showToggle]="true" [helpId]="sectionId"></forms-help>
          <formly [form]="form" [fields]="fields" [model]="model"></formly>
        </collapsible-pane>
      </div>
    </ng-template>

    <ng-container *ngTemplateOutlet="collapsible ? collapsibleField : regularField"></ng-container>
  `
})
export class FormsContainerComponent implements AfterViewInit {
  @Input() public collapsible: boolean;
  @Input() public collapsed: boolean = true;
  @Input() public sectionTitle: string;
  @Input() public sectionHelp: IGAFormHelper;
  @Input() public sectionId: string;
  @Input() public form: UntypedFormGroup;
  @Input() public fields: IExtraFieldConfigurationObject[];
  @Input() public model: any;

  @ViewChild('regularField', { read: TemplateRef }) private regularFieldLayout: TemplateRef<any>;
  @ViewChild('collapsibleField', { read: TemplateRef }) private collapsibleFieldLayout: TemplateRef<any>;
  public preferredLayout: TemplateRef<any>;

  constructor() {
    /**/
  }

  public ngAfterViewInit():void {
    // set preferred layout
    this.preferredLayout = this.collapsible? this.collapsibleFieldLayout : this.regularFieldLayout;
  }
}